export default __webpack_public_path__ + "static/fakegoogle_animation-e423c1f5df1703be4c9cb8da7728a44f.gif";